export function coerce(a) {
  return a
}
